import { PublicClientApplication } from "@azure/msal-browser";
import { AuthGuard } from "AuthGuard";
import { ClaimList } from "components/pages/claim-list/ClaimList";
import { CustomerList } from "components/pages/customer-list/CustomerList";
import { Home } from "components/pages/home/Home";
import { MyProfile } from "components/pages/my-profile/MyProfile";
import { ClaimDetails } from "components/pages/new-claim/ClaimDetails";
import { NewClaim } from "components/pages/new-claim/NewClaim";
import { AddUser } from "components/pages/user-list/AddUser";
import { NewUser } from "components/pages/user-list/NewUser";
import { UserList } from "components/pages/user-list/UserList";
import { AddWorkflow } from "components/pages/workflow-list/AddWorkflow";
import { NewWorkflow } from "components/pages/workflow-list/NewWorkflow";
import { WorkflowList } from "components/pages/workflow-list/WorkflowList";
import { createBrowserRouter, Link, Route, Routes } from "react-router-dom";

interface AppRoutesProps {
    msalInstance: PublicClientApplication;
}

export default function AppRoutes(props: AppRoutesProps) {
    return (
        <>
            {/* <AuthGuard msalInstance={props.msalInstance}> */}
                <Routes>
                    <Route path="/" element={<Home children={<></>} />} />
                    <Route path="/viewclaims" element={<ClaimList children={<></>} />} />
                    <Route path="/newclaim" element={<NewClaim children={<></>} />} />
                    <Route path="/users" element={<UserList children={<></>} />} />
                    <Route path="/claimdetails/:claimId" element={<ClaimDetails />} />
                    <Route path="/workflows" element={<WorkflowList children={<></>} />} />
                    <Route path="/addworkflow" element={<AddWorkflow children={<></>} />} />
                    <Route path="/newworkflow/:name/:type" element={<NewWorkflow children={<></>} />} />
                    <Route path="/newuser" element={<NewUser children={<></>} />} />
                    <Route path="/addEditUser" element={<AddUser children={<></>} />} />
                    <Route path="/addEditUser/:userId" element={<AddUser children={<></>} />} />
                    <Route path="/myprofile" element={<MyProfile children={<></>} />} />
                </Routes>
            {/* </AuthGuard> */}
        </>
    );
}
